<script>
import {calculateOverallAverage} from "../services/StatusDataToChartData";

export default {
  name: "OverallDevelopmentScore",
  props: {
    statusData: {
      type: Object,
      required: true
    }
  },
  computed: {
    overallScore() {
      return calculateOverallAverage(this.statusData);
    },
    biggestGrade() {
      return this.statusData.grade.reduce((prev, current) => (prev.grade > current.grade) ? prev : current);
    }
  }
}
</script>

<template>
  <div class="card card-border">
    <i class="overflow-arrow text-gray-900 fi-rr-arrow-right"></i>
    <div class="py-2 text-center">
      <h4 class="text-dark-sky">Overall: {{ overallScore }}/{{ biggestGrade.value }}</h4>
    </div>
  </div>
</template>

<style scoped>
.overflow-arrow {
  position: absolute;
  top: 0.75rem;
  bottom: auto;
  left: -10px;
  font-size: 1.5rem;
}
</style>